import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { getPatternImages } from '../../../../../helpers/getPatternImages';

// export const VenetianBlinds25 = React.forwardRef(
//   (
//     props: React.SVGProps<SVGSVGElement>,
//     setProductImageRef: React.Ref<SVGSVGElement>,
//   ) => {

export const VenetianBlinds25 = (props: React.SVGProps<SVGSVGElement>) => {
  const [state] = useService(productBuilderMachine);
  const patternUrl = getPatternImages(state);

  const valance =
    typeof state.context.custom.venetianValance === 'number' ? 'Yes' : '';

  if (valance !== 'Yes') {
    return (
      <svg
        id="prefix__Layer_1"
        data-name="Layer 1"
        viewBox="0 0 554.21 415"
        {...props}
        preserveAspectRatio="none"
      >
        <defs>
          <pattern
            id="venetianBlind25"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <linearGradient
            id="prefix__linear-gradient"
            x1={276.14}
            y1={233.6}
            x2={276.14}
            y2={242.89}
            gradientTransform="matrix(1 0 0 -1 0 256)"
            gradientUnits="userSpaceOnUse"
            preserveAspectRatio="none"
          >
            <stop offset={0.49} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.3} />
          </linearGradient>
          <linearGradient
            id="prefix__linear-gradient-2"
            x1={276.14}
            y1={221.76}
            x2={276.14}
            y2={231.05}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-3"
            x1={276.14}
            y1={209.92}
            x2={276.14}
            y2={219.21}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-4"
            x1={276.14}
            y1={198.08}
            x2={276.14}
            y2={207.37}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-5"
            x1={276.14}
            y1={186.24}
            x2={276.14}
            y2={195.53}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-6"
            x1={276.14}
            y1={174.41}
            x2={276.14}
            y2={183.69}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-7"
            x1={276.14}
            y1={162.57}
            x2={276.14}
            y2={171.85}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-8"
            x1={276.14}
            y1={150.73}
            x2={276.14}
            y2={160.01}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-9"
            x1={276.14}
            y1={138.89}
            x2={276.14}
            y2={148.17}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-10"
            x1={276.14}
            y1={127.05}
            x2={276.14}
            y2={136.33}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-11"
            x1={276.14}
            y1={115.21}
            x2={276.14}
            y2={124.49}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-12"
            x1={276.14}
            y1={103.37}
            x2={276.14}
            y2={112.65}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-13"
            x1={276.14}
            y1={91.53}
            x2={276.14}
            y2={100.81}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-14"
            x1={276.14}
            y1={79.69}
            x2={276.14}
            y2={88.97}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-15"
            x1={276.14}
            y1={67.85}
            x2={276.14}
            y2={77.13}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-16"
            x1={276.14}
            y1={56.01}
            x2={276.14}
            y2={65.29}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-17"
            x1={276.14}
            y1={44.17}
            x2={276.14}
            y2={53.45}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-18"
            x1={276.14}
            y1={32.33}
            x2={276.14}
            y2={41.61}
            xlinkHref="#prefix__linear-gradient"
          />
          <linearGradient
            id="prefix__linear-gradient-19"
            x1={276.14}
            y1={20.49}
            x2={276.14}
            y2={29.77}
            xlinkHref="#prefix__linear-gradient"
          />
          <style>
            {'.prefix__cls-22{fill:none;stroke:gray;stroke-miterlimit:10}'}
          </style>
        </defs>
        <path
          d="M554.21 10.06V0H0v10.06h91.37v3H15S5 16.56 5 22.4h86.37V25H15S5 28.4 5 34.24h86.37v2.55H15S5 40.24 5 46.08h86.37v2.55H15S5 52.08 5 57.92h86.37v2.55H15S5 63.92 5 69.76h86.37v2.55H15S5 75.76 5 81.59h86.37v2.56H15S5 87.6 5 93.43h86.37V96H15s-10 3.44-10 9.27h86.37v2.56H15s-10 3.45-10 9.28h86.37v2.56H15S5 123.12 5 129h86.37v2.56H15S5 135 5 140.79h86.37v2.56H15s-10 3.45-10 9.28h86.37v2.56H15s-10 3.45-10 9.28h86.37V167H15s-10 3.45-10 9.28h86.37v2.56H15s-10 3.45-10 9.28h86.37v2.56H15S5 194.16 5 200h86.37v2.56H15S5 206 5 211.83h86.37v2.56H15s-10 3.45-10 9.28h86.37v2.56H15s-10 3.45-10 9.28h86.37v2.86H0v13.26h87.84a2.09 2.09 0 00-.29 4.17h8.36a2.09 2.09 0 000-4.17h177.24a2.09 2.09 0 000 4.17h8.07a2.09 2.09 0 000-4.17H458.8a2.09 2.09 0 000 4.17h8.07a2.09 2.09 0 00.29-4.17h87.05v-13.26h-90.87v-2.86h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87V200h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87V129h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.61h85.87c0-5.48-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.48-10-9.28-10-9.28h-75.87v-2.55h85.87c0-5.49-10-9.29-10-9.29h-75.87v-2.55h85.87c0-5.49-10-9.29-10-9.29h-75.87v-2.55h85.87c0-5.49-10-9.29-10-9.29h-75.87v-2.55h85.87c0-5.49-10-9.29-10-9.29h-75.87V22.4h85.87c0-5.49-10-9.29-10-9.29h-75.87v-3zM276.61 22.4V25H98.49v-2.6zM98.49 13.11v-3h178.12v3zm178.12 21.13v2.55H98.49v-2.55zm0 11.84v2.55H98.49v-2.55zm0 11.84v2.55H98.49v-2.55zm0 11.84v2.55H98.49v-2.55zm0 11.83v2.56H98.49v-2.56zm0 11.84V96H98.49v-2.57zm0 11.84v2.56H98.49v-2.56zm0 11.84v2.56H98.49v-2.56zm0 11.84v2.56H98.49V129zm0 11.84v2.56H98.49v-2.56zm0 11.84v2.56H98.49v-2.56zm0 11.84V167H98.49v-2.56zm0 11.84v2.56H98.49v-2.56zm0 11.84v2.56H98.49v-2.56zm0 11.84v2.56H98.49V200zm0 11.84v2.56H98.49v-2.56zm0 11.84v2.56H98.49v-2.56zm0 11.84v2.86H98.49v-2.86zm1 0h177.17v2.86H277.61zm0-9.28v-2.56h177.17v2.56zm0-11.84v-2.56h177.17v2.56zm0-11.84V200h177.17v2.56zm0-11.84v-2.56h177.17v2.56zm0-11.84v-2.56h177.17v2.56zm0-11.84v-2.56h177.17V167zm0-11.84v-2.56h177.17v2.56zm0-11.84v-2.56h177.17v2.56zm0-11.84V129h177.17v2.56zm0-11.84v-2.56h177.17v2.56zm0-11.84v-2.56h177.17v2.56zm0-11.84v-2.56h177.17V96zm0-11.84v-2.56h177.17v2.56zm0-11.84v-2.55h177.17v2.55zm0-11.84v-2.55h177.17v2.55zm0-11.84v-2.55h177.17v2.55zm0-11.84v-2.55h177.17v2.55zm0-11.84V22.4h177.17V25zm0-11.84v-3h177.17v3zm-185.24-3h5.12v3h-5.12zm0 12.34h5.12V25h-5.12zm0 11.84h5.12v2.55h-5.12zm0 11.84h5.12v2.55h-5.12zm0 11.84h5.12v2.55h-5.12zm0 11.84h5.12v2.55h-5.12zm0 11.83h5.12v2.56h-5.12zm0 11.84h5.12V96h-5.12zm0 11.84h5.12v2.56h-5.12zm0 11.84h5.12v2.56h-5.12zm0 11.84h5.12v2.56h-5.12zm0 11.84h5.12v2.56h-5.12zm0 11.84h5.12v2.56h-5.12zm0 11.84h5.12V167h-5.12zm0 11.84h5.12v2.56h-5.12zm0 11.84h5.12v2.56h-5.12zm0 11.84h5.12v2.56h-5.12zm0 11.84h5.12v2.56h-5.12zm0 11.84h5.12v2.56h-5.12zm0 11.84h5.12v2.86h-5.12zm370 2.86h-6.56v-2.86h6.56zm0-12.14h-6.56v-2.56h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56V200h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56V129h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56v-2.61h6.56zm0-11.84h-6.56v-2.61h6.56zm0-11.84h-6.56v-2.6h6.56zm0-11.84h-6.56v-2.6h6.56zm0-11.84h-6.56v-2.6h6.56zm0-11.84h-6.56v-2.6h6.56zm0-11.84h-6.56v-2.6h6.56zm0-11.84h-6.56v-3h6.56z"
          fill="url(#venetianBlind25)"
        />
        <path
          d="M548.25 22.4H4c0-5.84 10-9.29 10-9.29h524.25s10 3.8 10 9.29z"
          fill="url(#prefix__linear-gradient)"
        />
        <path
          d="M548.25 34.24H4C4 28.4 14 25 14 25h524.25s10 3.75 10 9.24z"
          fill="url(#prefix__linear-gradient-2)"
        />
        <path
          d="M548.25 46.08H4c0-5.84 10-9.29 10-9.29h524.25s10 3.8 10 9.29z"
          fill="url(#prefix__linear-gradient-3)"
        />
        <path
          d="M548.25 57.92H4c0-5.84 10-9.29 10-9.29h524.25s10 3.8 10 9.29z"
          fill="url(#prefix__linear-gradient-4)"
        />
        <path
          d="M548.25 69.76H4c0-5.84 10-9.29 10-9.29h524.25s10 3.8 10 9.29z"
          fill="url(#prefix__linear-gradient-5)"
        />
        <path
          d="M548.25 81.59H4c0-5.83 10-9.28 10-9.28h524.25s10 3.8 10 9.28z"
          fill="url(#prefix__linear-gradient-6)"
        />
        <path
          d="M548.25 93.43H4c0-5.83 10-9.28 10-9.28h524.25s10 3.85 10 9.28z"
          fill="url(#prefix__linear-gradient-7)"
        />
        <path
          d="M548.25 105.27H4C4 99.44 14 96 14 96h524.25s10 3.78 10 9.27z"
          fill="url(#prefix__linear-gradient-8)"
        />
        <path
          d="M548.25 117.11H4c0-5.83 10-9.28 10-9.28h524.25s10 3.79 10 9.28z"
          fill="url(#prefix__linear-gradient-9)"
        />
        <path
          d="M548.25 129H4c0-5.83 10-9.28 10-9.28h524.25s10 3.74 10 9.28z"
          fill="url(#prefix__linear-gradient-10)"
        />
        <path
          d="M548.25 140.79H4c0-5.83 10-9.28 10-9.28h524.25s10 3.79 10 9.28z"
          fill="url(#prefix__linear-gradient-11)"
        />
        <path
          d="M548.25 152.63H4c0-5.83 10-9.28 10-9.28h524.25s10 3.79 10 9.28z"
          fill="url(#prefix__linear-gradient-12)"
        />
        <path
          d="M548.25 164.47H4c0-5.83 10-9.28 10-9.28h524.25s10 3.81 10 9.28z"
          fill="url(#prefix__linear-gradient-13)"
        />
        <path
          d="M548.25 176.31H4c0-5.83 10-9.31 10-9.31h524.25s10 3.82 10 9.31z"
          fill="url(#prefix__linear-gradient-14)"
        />
        <path
          d="M548.25 188.15H4c0-5.83 10-9.28 10-9.28h524.25s10 3.79 10 9.28z"
          fill="url(#prefix__linear-gradient-15)"
        />
        <path
          d="M548.25 200H4c0-5.83 10-9.28 10-9.28h524.25s10 3.78 10 9.28z"
          fill="url(#prefix__linear-gradient-16)"
        />
        <path
          d="M548.25 211.83H4c0-5.83 10-9.28 10-9.28h524.25s10 3.79 10 9.28z"
          fill="url(#prefix__linear-gradient-17)"
        />
        <path
          d="M548.25 223.67H4c0-5.83 10-9.28 10-9.28h524.25s10 3.79 10 9.28z"
          fill="url(#prefix__linear-gradient-18)"
        />
        <path
          d="M548.25 235.51H4c0-5.83 10-9.28 10-9.28h524.25s10 3.77 10 9.28z"
          fill="url(#prefix__linear-gradient-19)"
        />
        <g opacity={0.25}>
          <path
            className="prefix__cls-22"
            d="M277.15 10.06v241.57M462.88 10.06v241.57M455.32 10.06v3.05M455.32 22.4v2.55M455.32 34.24v2.55M455.32 46.08v2.55M455.32 57.92v2.55M455.32 69.76v2.55M455.32 81.59v2.56M455.32 93.43v2.56M455.32 105.27v2.56M455.32 117.11v2.56M455.32 128.95v2.56M455.32 140.79v2.56M455.32 152.63v2.56M455.32 164.47v2.56M455.32 176.31v2.56M455.32 188.15v2.56M455.32 199.99v2.56M455.32 211.83v2.56M455.32 223.67v2.56M455.32 235.66v2.56M91.91 10.06v241.57M98.03 10.06v3.05M98.03 22.4v2.55M98.03 34.24v2.55M98.03 46.08v2.55M98.03 57.92v2.55M98.03 69.76v2.55M98.03 81.59v2.56M98.03 93.43v2.56M98.03 105.27v2.56M98.03 117.11v2.56M98.03 128.95v2.56M98.03 140.79v2.56M98.03 152.63v2.56M98.03 164.47v2.56M98.03 176.31v2.56M98.03 188.15v2.56M98.03 199.99v2.56M98.03 211.83v2.56M98.03 223.67v2.56M98.03 235.66v2.56"
          />
        </g>
      </svg>
    );
  } else {
    return (
      <svg
        id="prefix__Layer_1"
        data-name="Layer 1"
        viewBox="0 0 554.21 251.8"
        {...props}
      >
        <defs>
          <pattern
            id="venetianBlind25"
            patternUnits="userSpaceOnUse"
            width="100"
            height="100"
          >
            <image href={patternUrl} x="0" y="0" width="100" height="100" />
          </pattern>
        </defs>
        <defs>
          <linearGradient
            id="prefix__New_Gradient_Swatch_1"
            x1={276.61}
            y1={23.4}
            x2={276.61}
            y2={18.75}
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0.49} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.3} />
          </linearGradient>
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-2"
            x1={276.61}
            y1={35.24}
            x2={276.61}
            y2={25.95}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-3"
            x1={276.61}
            y1={47.08}
            x2={276.61}
            y2={37.79}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-4"
            x1={276.61}
            y1={58.92}
            x2={276.61}
            y2={49.63}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-5"
            x1={276.61}
            y1={70.76}
            x2={276.61}
            y2={61.47}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-6"
            x1={276.61}
            y1={82.59}
            x2={276.61}
            y2={73.31}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-7"
            x1={276.61}
            y1={94.43}
            x2={276.61}
            y2={85.15}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-8"
            x1={276.61}
            y1={106.27}
            x2={276.61}
            y2={96.99}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-9"
            x1={276.61}
            y1={118.11}
            x2={276.61}
            y2={108.83}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-10"
            x1={276.61}
            y1={129.95}
            x2={276.61}
            y2={120.67}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-11"
            x1={276.61}
            y1={141.79}
            x2={276.61}
            y2={132.51}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-12"
            x1={276.61}
            y1={153.63}
            x2={276.61}
            y2={144.35}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-13"
            x1={276.61}
            y1={165.47}
            x2={276.61}
            y2={156.19}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-14"
            x1={276.61}
            y1={177.31}
            x2={276.61}
            y2={168.03}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-15"
            x1={276.61}
            y1={189.15}
            x2={276.61}
            y2={179.87}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-16"
            x1={276.61}
            y1={200.99}
            x2={276.61}
            y2={191.71}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-17"
            x1={276.61}
            y1={212.83}
            x2={276.61}
            y2={203.55}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-18"
            x1={276.61}
            y1={224.67}
            x2={276.61}
            y2={215.39}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <linearGradient
            id="prefix__New_Gradient_Swatch_1-19"
            x1={276.61}
            y1={236.51}
            x2={276.61}
            y2={227.23}
            xlinkHref="#prefix__New_Gradient_Swatch_1"
          />
          <style>
            {'.prefix__cls-22{fill:none;stroke:gray;stroke-miterlimit:10}'}
          </style>
        </defs>
        <path
          d="M0 0v18.75h7.23A6.7 6.7 0 005 23.4h86.37V26H15S5 29.4 5 35.24h86.37v2.55H15S5 41.24 5 47.08h86.37v2.55H15S5 53.08 5 58.92h86.37v2.55H15S5 64.92 5 70.76h86.37v2.55H15S5 76.76 5 82.59h86.37v2.56H15S5 88.6 5 94.43h86.37V97H15s-10 3.45-10 9.28h86.37v2.56H15s-10 3.45-10 9.28h86.37v2.56H15S5 124.12 5 130h86.37v2.56H15S5 136 5 141.79h86.37v2.56H15s-10 3.45-10 9.28h86.37v2.56H15s-10 3.45-10 9.28h86.37V168H15s-10 3.45-10 9.28h86.37v2.56H15s-10 3.45-10 9.28h86.37v2.56H15S5 195.16 5 201h86.37v2.56H15S5 207 5 212.83h86.37v2.56H15s-10 3.45-10 9.28h86.37v2.56H15s-10 3.45-10 9.28h86.37v2.86H0v8.26h87.84a2.09 2.09 0 100 4.17h8.07a2.09 2.09 0 000-4.17h177.24a2.09 2.09 0 000 4.17h8.07a2.09 2.09 0 000-4.17H458.8a2.09 2.09 0 000 4.17h8.07a2.09 2.09 0 100-4.17h87.34v-8.26h-90.87v-2.86h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87V201h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87V130h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.49-10-9.28-10-9.28h-75.87v-2.61h85.87c0-5.48-10-9.28-10-9.28h-75.87v-2.56h85.87c0-5.48-10-9.28-10-9.28h-75.87v-2.55h85.87c0-5.49-10-9.29-10-9.29h-75.87v-2.55h85.87c0-5.49-10-9.29-10-9.29h-75.87v-2.55h85.87c0-5.49-10-9.29-10-9.29h-75.87v-2.55h85.87c0-5.49-10-9.29-10-9.29h-75.87V23.4h85.87a6.7 6.7 0 00-2.38-4.65h7.38V0zm97.49 239.37h-5.12v-2.86h5.12zm0-12.14h-5.12v-2.56h5.12zm0-11.84h-5.12v-2.56h5.12zm0-11.84h-5.12V201h5.12zm0-11.84h-5.12v-2.56h5.12zm0-11.84h-5.12v-2.56h5.12zm0-11.84h-5.12v-2.56h5.12zm0-11.84h-5.12v-2.56h5.12zm0-11.84h-5.12v-2.56h5.12zm0-11.84h-5.12V130h5.12zm0-11.84h-5.12v-2.56h5.12zm0-11.84h-5.12v-2.56h5.12zm0-11.84h-5.12v-2.56h5.12zm0-11.84h-5.12v-2.56h5.12zm0-11.84h-5.12v-2.55h5.12zm0-11.84h-5.12v-2.55h5.12zm0-11.84h-5.12v-2.55h5.12zm0-11.84h-5.12v-2.55h5.12zm0-11.84h-5.12V23.4h5.12zm179.12 213.42H98.49v-2.86h178.12zm0-12.14H98.49v-2.56h178.12zm0-11.84H98.49v-2.56h178.12zm0-11.84H98.49V201h178.12zm0-11.84H98.49v-2.56h178.12zm0-11.84H98.49v-2.56h178.12zm0-11.84H98.49v-2.56h178.12zm0-11.84H98.49v-2.56h178.12zm0-11.84H98.49v-2.56h178.12zm0-11.84H98.49V130h178.12zm0-11.84H98.49v-2.56h178.12zm0-11.84H98.49v-2.56h178.12zm0-11.84H98.49v-2.56h178.12zm0-11.84H98.49v-2.56h178.12zm0-11.84H98.49v-2.55h178.12zm0-11.84H98.49v-2.55h178.12zm0-11.84H98.49v-2.55h178.12zm0-11.84H98.49v-2.55h178.12zm0-11.84H98.49V23.4h178.12zm178.17 213.42H277.61v-2.86h177.17zm0-12.14H277.61v-2.56h177.17zm0-11.84H277.61v-2.56h177.17zm0-11.84H277.61V201h177.17zm0-11.84H277.61v-2.56h177.17zm0-11.84H277.61v-2.56h177.17zm0-11.84H277.61v-2.56h177.17zm0-11.84H277.61v-2.56h177.17zm0-11.84H277.61v-2.56h177.17zm0-11.84H277.61V130h177.17zm0-11.84H277.61v-2.56h177.17zm0-11.84H277.61v-2.56h177.17zm0-11.84H277.61v-2.56h177.17zm0-11.84H277.61v-2.56h177.17zm0-11.84H277.61v-2.55h177.17zm0-11.84H277.61v-2.55h177.17zm0-11.84H277.61v-2.55h177.17zm0-11.84H277.61v-2.55h177.17zm0-11.84H277.61V23.4h177.17zm7.56 213.42h-6.56v-2.86h6.56zm0-12.14h-6.56v-2.56h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56V201h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56V130h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56v-2.56h6.56zm0-11.84h-6.56v-2.55h6.56zm0-11.84h-6.56v-2.55h6.56zm0-11.84h-6.56v-2.55h6.56zm0-11.84h-6.56v-2.55h6.56zm0-11.84h-6.56V23.4h6.56z"
          fill="url(#venetianBlind25)"
        />
        <path
          d="M546.33 18.75H6.73A6.7 6.7 0 004.5 23.4h544.21a6.7 6.7 0 00-2.38-4.65z"
          fill="url(#prefix__New_Gradient_Swatch_1)"
        />
        <path
          d="M548.71 35.24H4.5c0-5.84 10-9.29 10-9.29h524.21s10 3.8 10 9.29z"
          fill="url(#prefix__New_Gradient_Swatch_1-2)"
        />
        <path
          d="M548.71 47.08H4.5c0-5.84 10-9.29 10-9.29h524.21s10 3.8 10 9.29z"
          fill="url(#prefix__New_Gradient_Swatch_1-3)"
        />
        <path
          d="M548.71 58.92H4.5c0-5.84 10-9.29 10-9.29h524.21s10 3.8 10 9.29z"
          fill="url(#prefix__New_Gradient_Swatch_1-4)"
        />
        <path
          d="M548.71 70.76H4.5c0-5.84 10-9.29 10-9.29h524.21s10 3.8 10 9.29z"
          fill="url(#prefix__New_Gradient_Swatch_1-5)"
        />
        <path
          d="M548.71 82.59H4.5c0-5.83 10-9.28 10-9.28h524.21s10 3.8 10 9.28z"
          fill="url(#prefix__New_Gradient_Swatch_1-6)"
        />
        <path
          d="M548.71 94.43H4.5c0-5.83 10-9.28 10-9.28h524.21s10 3.85 10 9.28z"
          fill="url(#prefix__New_Gradient_Swatch_1-7)"
        />
        <path
          d="M548.71 106.27H4.5c0-5.83 10-9.28 10-9.28h524.21s10 3.79 10 9.28z"
          fill="url(#prefix__New_Gradient_Swatch_1-8)"
        />
        <path
          d="M548.71 118.11H4.5c0-5.83 10-9.28 10-9.28h524.21s10 3.79 10 9.28z"
          fill="url(#prefix__New_Gradient_Swatch_1-9)"
        />
        <path
          d="M548.71 130H4.5c0-5.83 10-9.28 10-9.28h524.21s10 3.74 10 9.28z"
          fill="url(#prefix__New_Gradient_Swatch_1-10)"
        />
        <path
          d="M548.71 141.79H4.5c0-5.83 10-9.28 10-9.28h524.21s10 3.79 10 9.28z"
          fill="url(#prefix__New_Gradient_Swatch_1-11)"
        />
        <path
          d="M548.71 153.63H4.5c0-5.83 10-9.28 10-9.28h524.21s10 3.79 10 9.28z"
          fill="url(#prefix__New_Gradient_Swatch_1-12)"
        />
        <path
          d="M548.71 165.47H4.5c0-5.83 10-9.28 10-9.28h524.21s10 3.81 10 9.28z"
          fill="url(#prefix__New_Gradient_Swatch_1-13)"
        />
        <path
          d="M548.71 177.31H4.5c0-5.83 10-9.28 10-9.28h524.21s10 3.79 10 9.28z"
          fill="url(#prefix__New_Gradient_Swatch_1-14)"
        />
        <path
          d="M548.71 189.15H4.5c0-5.83 10-9.28 10-9.28h524.21s10 3.79 10 9.28z"
          fill="url(#prefix__New_Gradient_Swatch_1-15)"
        />
        <path
          d="M548.71 201H4.5c0-5.83 10-9.28 10-9.28h524.21s10 3.78 10 9.28z"
          fill="url(#prefix__New_Gradient_Swatch_1-16)"
        />
        <path
          d="M548.71 212.83H4.5c0-5.83 10-9.28 10-9.28h524.21s10 3.79 10 9.28z"
          fill="url(#prefix__New_Gradient_Swatch_1-17)"
        />
        <path
          d="M548.71 224.67H4.5c0-5.83 10-9.28 10-9.28h524.21s10 3.79 10 9.28z"
          fill="url(#prefix__New_Gradient_Swatch_1-18)"
        />
        <path
          d="M548.71 236.51H4.5c0-5.83 10-9.28 10-9.28h524.21s10 3.77 10 9.28z"
          fill="url(#prefix__New_Gradient_Swatch_1-19)"
        />
        <g opacity={0.25}>
          <path
            className="prefix__cls-22"
            d="M276.61 18.75v228.88M462.34 18.75v228.88M454.78 23.4v2.55M454.78 35.24v2.55M454.78 47.08v2.55M454.78 58.92v2.55M454.78 70.76v2.55M454.78 82.59v2.56M454.78 94.43v2.56M454.78 106.27v2.56M454.78 118.11v2.56M454.78 129.95v2.56M454.78 141.79v2.56M454.78 153.63v2.56M454.78 165.47v2.56M454.78 177.31v2.56M454.78 189.15v2.56M454.78 200.99v2.56M454.78 212.83v2.56M454.78 224.67v2.56M454.78 236.66v2.56M91.37 18.75v228.88M97.49 23.4v2.55M97.49 35.24v2.55M97.49 47.08v2.55M97.49 58.92v2.55M97.49 70.76v2.55M97.49 82.59v2.56M97.49 94.43v2.56M97.49 106.27v2.56M97.49 118.11v2.56M97.49 129.95v2.56M97.49 141.79v2.56M97.49 153.63v2.56M97.49 165.47v2.56M97.49 177.31v2.56M97.49 189.15v2.56M97.49 200.99v2.56M97.49 212.83v2.56M97.49 224.67v2.56M97.49 236.66v2.56"
          />
        </g>
      </svg>
    );
  }
};
